const es = {
    nav: {
        manifesto: "Sobre mí",
        services: "Qué resuelvo",
        process: "Cómo funciona",
        work: "Casos de estudio",
        pricing: "Precios",
        blog: "Notas de campo",
        contact: "Contacto",
        bookCall: "Agendar llamada",
    },
    hero: {
        overline: "Austin, Texas · Desarrollador de software a medida · 20+ años construyendo herramientas",
        headlineA: "Convierto el caos operativo en",
        headlineEm: "herramientas que se pagan solas.",
        headlineB: "",
        body:
            "Hola, soy Guillermo. Me obsesiona construir herramientas desde que era un niño frente a una torre con Windows 95 — esa obsesión es la que me empujó a estudiar esta carrera y la que me mantiene en ella, 20+ años después. Trabajo con un cliente a la vez, el alcance es real antes de escribir una línea de código, y el precio se acuerda de entrada.",
        ctaCall: "Agendar llamada de descubrimiento",
        ctaWhatsapp: "Escríbeme por WhatsApp",
        stats: [
            { k: "20+", label: "Años construyendo herramientas" },
            { k: "1–3 sem", label: "Tiempo promedio de build" },
            { k: "Claro", label: "Sin facturas sorpresa" },
            { k: "Mensual", label: "Cuidado desde el día 1" },
        ],
    },
    manifesto: {
        overline: "Una nota desde el estudio",
        portraitAlt: "Guillermo Figueroa Mesa en WordCamp Europe, Porto",
        waterAlt: "En el agua",
        caption:
            "En la foto: en el agua — el único lugar donde dejo que el trabajo espere.",
        headlineA: "Veinte+ años de código,",
        headlineEm: "una manía obstinada:",
        headlineB: "resolver el rompecabezas que tengo enfrente.",
        p1A: "Llevo veinte años construyendo el software detrás del negocio de otras personas — el sitio que captura una reserva mientras estás en el escenario, la herramienta que evita que se pierda un pedido, el panel donde el dueño no técnico actualiza precios sin llamar a un desarrollador por un typo. Lo he hecho para startups y equipos pequeños de EE.UU., Europa y Latinoamérica — incluyendo experiencias de Google Assistant en ",
        p1Jam: "Jam3",
        p1B: ".",
        p2A: "La mayoría de los negocios pequeños no necesitan una agencia, un sprint de 12 semanas, ni un Notion lleno de canales de Slack. Necesitan ",
        p2Em: "un solo desarrollador",
        p2B: " que pueda escuchar esta semana, definir el alcance la próxima, y contestar el teléfono cuando algo necesite un ajuste.",
        p3: "Eso es lo que hago aquí, en mi propio tiempo, fuera de mi agencia — para que el precio sea honesto, la relación se mantenga personal, y tu producto siga vivo mucho después del screenshot del lanzamiento.",
        p4:
            "No construyo software porque esté de moda. Lo construyo porque resolver el rompecabezas que tengo enfrente es lo único que ha sostenido mi atención por veinte+ años. Es la razón por la que estudié esta carrera, y la razón por la que sigo en ella.",
    },
    services: {
        overline: "Qué resuelvo",
        headlineA: "Dos problemas.",
        headlineEm: "Un solo humano",
        headlineB: "construyendo la solución.",
        intro:
            "Mantengo la oferta corta a propósito. Cada engagement se define y se cotiza de entrada después de un assessment pagado, y cada build viene con cuidado mensual opcional para que tu herramienta no se pudra en silencio seis meses después.",
        enquire: "Escríbeme",
        tracks: [
            {
                kicker: "Pista 01 · Cara al cliente",
                title: "El sitio web que tu negocio se merece — uno que contesta el teléfono cuando tú no puedes.",
                desc: "Sitios editoriales a medida que convierten a un visitante en una llamada agendada, un evento reservado o una orden pagada — mientras tú estás haciendo otra cosa. No plantillas. No el mismo sitio que tu competencia ya usó.",
                deliverables: [
                    "Un sitio público que captura leads mientras duermes",
                    "Booking, WhatsApp, SMS o Calendly en la página",
                    "Aparecés en Google sin tener que cuidarlo tú",
                    "Editá typos y actualizá páginas vos mismo — sin llamar a nadie",
                ],
                cta: "Desde $3,780",
            },
            {
                kicker: "Pista 02 · Trastienda",
                title: "La herramienta que evita que tu negocio corra en WhatsApp y memoria.",
                desc: "Una herramienta privada que le quita el caos a tu operación — pedidos, inventario, reservas, entregas de equipo. Construida alrededor de cómo ya trabajas, no cómo un SaaS desearía que trabajaras.",
                deliverables: [
                    "Una herramienta privada ajustada a tu flujo diario",
                    "Se conecta con los sistemas que ya usas — pagos, e-commerce, lo que sea",
                    "Reemplaza copiar-pegar, planillas y updates manuales",
                    "Cada miembro del equipo ve solo su parte — sin borrados accidentales",
                ],
                cta: "Desde $6,650",
            },
        ],
    },
    process: {
        overline: "Cómo funciona",
        headlineA: "Un",
        headlineEm: "camino",
        headlineB: "corto y honesto, del problema al live.",
        intro:
            "Sin deck de descubrimiento, sin sprint cero, sin \"déjame sincronizar con mi PM\". Cada proyecto empieza con un assessment pagado para que el alcance sea real antes de escribir una sola línea de código.",
        stepLabel: "Paso",
        steps: [
            {
                n: "01",
                title: "Assessment",
                body: "Una auditoría pagada de 1 a 2 días (US$500) en la que me sumerjo en tu negocio, tu stack y lo que realmente necesitas construir. Te llevas un informe escrito claro — tuyo, incluso si no trabajamos juntos.",
            },
            {
                n: "02",
                title: "Propuesta",
                body: "Un solo documento corto, anclado en el assessment: alcance, entregables, un número, un plazo. Sin retainers escondidos en PDFs, sin sorpresas por change orders después.",
            },
            {
                n: "03",
                title: "Construcción",
                body: "Lo construyo en tu dominio, comparto el avance en vivo y lo subo a producción. El tiempo promedio de build es de 1 a 3 semanas. No pagas nada más hasta que lo veas funcionando.",
            },
            {
                n: "04",
                title: "Cuidado",
                body: "Eliges un plan de cuidado mensual (o no). Hosting, ajustes de contenido, fixes de bugs, pequeñas features nuevas — manejado por la misma persona que lo construyó.",
            },
        ],
    },
    portfolio: {
        overline: "Casos de estudio · 2025",
        headlineA: "Cada proyecto es el",
        headlineEm: "sistema completo",
        headlineB:
            "— la cara pública y la herramienta privada detrás.",
        liveBadge: "Sitio en vivo",
        privateBadge: "Privado · Interno",
        privateNote: "Build privado · caso de estudio bajo solicitud",
        visit: "Visitar",
        readCaseStudy: "Leer el caso de estudio",
        backToHome: "Volver a todos los casos",
        seeAll: "Ver todos los casos de estudio",
        filters: {
            allLabel: "Todos",
            industryTitle: "Industria",
            productTypeTitle: "Tipo de producto",
            outcomeTitle: "Resultado",
            reset: "Limpiar filtros",
            empty: "Ningún caso de estudio coincide con esos filtros. Probá quitar uno.",
            resultsOne: "caso de estudio",
            resultsMany: "casos de estudio",
            industries: {
                "music-arts": "Música y Artes",
                manufacturing: "Manufactura",
                "saas-ops": "SaaS y Operaciones",
                hospitality: "Hospitalidad",
                "food-beverage": "Comida y Bebida",
            },
            productTypes: {
                "public-site": "Sitio público",
                "internal-dashboard": "Dashboard interno",
                "internal-erp": "ERP interno",
                chatbot: "Chatbot",
                automation: "Automatización",
                ai: "Con IA",
                analytics: "Analítica",
            },
            outcomes: {
                "capture-leads": "Capturar más leads",
                "sell-more": "Vender más",
                "automate-ops": "Automatizar operaciones",
                "save-time": "Ahorrar horas por semana",
                "self-serve": "Editar sin depender",
                "understand-users": "Entender a tus clientes",
            },
        },
        index: {
            metaTitle: "Casos de estudio · Guillermo Figueroa Mesa | gfirem",
            metaDescription:
                "Cada proyecto de software a medida que he entregado para emprendedores y equipos pequeños — sitios públicos, dashboards internos, ERPs y automatizaciones. Filtrá por industria, tipo de producto o el resultado que buscás.",
            overline: "Trabajo seleccionado · 2005 → hoy",
            headlineA: "Cada herramienta que he entregado,",
            headlineEm: "con el problema que resolvió.",
            headlineB: "",
            intro:
                "Filtrá por industria, por la forma de la herramienta o por el resultado de negocio que estás buscando. Cada entrada lleva a un caso de estudio completo con el problema, lo que construí y el resultado.",
        },
        related: {
            title: "Casos de estudio relacionados",
            subtitle: "Otro trabajo del mismo vecindario.",
        },
        sidebar: {
            client: "Cliente",
            category: "Categoría",
            location: "Ubicación",
            liveSite: "Sitio en vivo",
            access: "Acceso",
        },
        labels: {
            problem: "El problema",
            solution: "Qué construí",
            outcome: "El resultado",
        },
        bottomNote:
            "Hay otro puñado de proyectos que viven en silencio dentro de empresas — agencias, e-commerce, startups Web3. Con gusto los comparto en una llamada.",
        works: [
            {
                n: "01",
                client: "Terry Barber",
                location: "New Jersey · Se presenta en todo el mundo",
                category: "Artista en gira · Contratenor",
                outcomeKicker: "Actualiza el sitio desde el celular, en gira",
                title:
                    "El sitio de un artista en gira que publica trabajo nuevo más rápido de lo que se mueve el bus de la gira.",
                intro:
                    "Admin auto-editable desde el teléfono, analítica first-party que sugiere mejoras, y un chat en el sitio que atrapa reservas mientras Terry está en la carretera.",
                problem:
                    "Un contratenor en gira necesitaba actualizar su sitio cada vez que cambiaba un programa, un álbum o una fecha — y cada cambio era un ticket a un desarrollador. Las reservas y consultas de prensa llegaban por un formulario que nadie miraba entre shows.",
                solution:
                    "Un sitio de artista performance-first con admin auto-editable completo: programas, álbumes, quotes de prensa, fechas de gira y FAQs — todo editable desde el teléfono. Analítica first-party que propone mejoras automáticamente, un chat en el sitio que le llega esté donde esté, y performance en verde de Lighthouse en mobile y desktop.",
                outcome:
                    "Terry publica su trabajo el momento en que existe. El admin le dice qué está funcionando (y qué arreglar) sin que tenga que leer un gráfico. Las reservas llegan por chat en vivo en vez de morir en un formulario. Los visitantes en móvil ven el mismo sitio rápido y cinemático que en desktop.",
                meta: ["Admin auto-editable", "Analítica first-party", "Chat + booking"],
            },
            {
                n: "02",
                client: "DGE Cigars ERP",
                location: "Producto interno · Santo Domingo ↔ EE.UU.",
                category: "Manufactura · Pedidos · Fulfillment",
                outcomeKicker: "Cero emails de \"¿dónde está mi pedido?\"",
                title: "Un ERP que conecta el storefront con el piso de la fábrica.",
                intro:
                    "Un solo timeline por pedido desde el checkout de WooCommerce hasta la fábrica en Santo Domingo y el buzón del cliente en EE.UU. — se acabó el copy-paste en WhatsApp.",
                problem:
                    "Los pedidos de WooCommerce caían en un inbox, la fábrica de tabaco en Santo Domingo trabajaba desde un grupo de WhatsApp, y los envíos pasaban en una tercera pestaña. Cada actualización de estado se tecleaba a mano en WhatsApp, y los clientes no tenían idea de dónde estaban sus tabacos.",
                solution:
                    "Un ERP a medida que unifica storefront → fábrica → carrier. Un solo timeline por pedido (Nuevo → En producción → Listo para envío → Enviado → Entregado), tracking del carrier auto-adjunto, enrutamiento de fulfillment por pedido, y una página de estado que el cliente final puede consultar.",
                outcome:
                    "El equipo de la fábrica en Santo Domingo actualiza un estado una sola vez y le llega al cliente en EE.UU. al instante — se acabó el copy-paste en WhatsApp. Los emails de \"¿dónde está mi pedido?\" desaparecieron en silencio.",
                meta: ["Sync con WooCommerce", "Timeline de estados", "Tracking de carrier"],
            },
            {
                n: "03",
                client: "Scalater Command Center",
                location: "Producto interno · Austin",
                category: "Operaciones · DORA · IA",
                outcomeKicker: "300+ requests en un solo dashboard",
                title: "Un centro de mando interno para un estudio de software.",
                intro:
                    "300+ requests activos, 30 plantillas de proceso reutilizables, métricas DORA + custom y un asistente de IA embebido — tres modos: ingenieros, ops y clientes.",
                problem:
                    "Un estudio de software creciendo manejaba 300+ requests activos entre DMs de Slack, emails y hojas de cálculo. Nadie sabía qué clientes estaban comprometidos esta semana, qué procesos estaban documentados, o cómo el equipo pasaba realmente sus horas.",
                solution:
                    "Un centro de mando interno con métricas custom + DORA, 30 plantillas de proceso reutilizables, analítica de page-views por portal de cliente, y un asistente de IA embebido. Tres modos: ingenieros, ops, y clientes.",
                outcome:
                    "Los ingenieros dejaron de reinventar el onboarding cada vez. Ops ve cuándo un cliente se está apagando antes de que desaparezca. Los clientes ven el mismo dashboard que el equipo, así que la confianza compone en vez de gotear.",
                meta: ["Métricas custom + DORA", "Asistente IA", "Modo cliente + equipo"],
            },
            {
                n: "04",
                client: "López Hill",
                location: "Spicewood, Texas",
                category: "Venue boutique para bodas",
                outcomeKicker: "Un solo inbox, más bodas cerradas",
                title: "Un sitio público, un chatbot de leads y un portal privado de equipo.",
                intro:
                    "Sitio editorial del venue, un chatbot 24/7 que pre-califica a las parejas, y un portal mobile-first para que la familia López conteste menos mensajes y reserve más bodas.",
                problem:
                    "Un venue familiar en las hill country contestaba consultas de bodas entre DMs de Instagram, WhatsApp, llamadas telefónicas que no siempre podían atender, y emails de \"contacto\". Los leads se escapaban entre los dedos cada semana. La familia no usa hojas de cálculo — usa teléfonos.",
                solution:
                    "Un sitio editorial público, una página de producto de cata de tequila, un chatbot que califica a las parejas 24/7 (incluso cuando el teléfono suena sin respuesta), y un dashboard privado mobile-first donde la familia López confirma consultas, lleva las reservas y revisa las conversaciones del chatbot.",
                outcome:
                    "Cada pareja que visita el sitio cae en una sola cola que la familia sí revisa. El chatbot pre-califica antes de que entre el humano, así que la familia contesta menos mensajes y reserva más bodas.",
                meta: ["Sitio editorial", "Chatbot de leads", "Portal de equipo"],
            },
            {
                n: "05",
                client: "Island Flavors",
                location: "Austin, Texas",
                category: "Catering de inspiración latina",
                outcomeKicker: "Actualizar el menú toma minutos, no días",
                title:
                    "Un storefront bilingüe, un menú de catering y un admin auto-editable.",
                intro:
                    "Landing bilingüe, menús de cena en tres niveles con precio por invitado, un admin donde ella misma edita los platos y un generador de códigos QR que los clientes escanean la noche del evento.",
                problem:
                    "Una cocinera emprendedora latina servía al mercado bilingüe de Austin desde su cocina — mandando PDFs de menús de tres niveles con precio por invitado, respondiendo las mismas preguntas cada semana, y llamando a su desarrollador cada vez que cambiaba un plato. En los eventos, los menús impresos se perdían o se veían fuera de marca.",
                solution:
                    "Un landing bilingüe, menús de cena en tres niveles con precio por invitado, un admin privado donde ella misma edita los platos, y un generador de códigos QR que los clientes escanean la noche del evento.",
                outcome:
                    "Los menús se actualizan en minutos, no días. Los invitados bilingües leen el menú en su idioma. Ella dejó de ser webmaster de medio tiempo — y sus eventos servidos se sienten como una marca, no como un Google Doc.",
                meta: ["Sitio bilingüe", "Menú de catering", "QR + admin auto-editable"],
            },
        ],
    },
    testimonials: {
        overline: "En sus palabras",
        headlineA: "Elogios discretos de",
        headlineEm: "la gente con la que realmente he lanzado.",
        items: [
            {
                body:
                    "Guille lanzó nuestra herramienta interna de pedidos en una semana. Tres años después sigue corriendo, y él sigue siendo la persona a la que escribimos cuando algo se rompe.",
                author: "Founder · Foodhuggers",
                place: "EE.UU.",
            },
            {
                body:
                    "Necesitábamos a alguien que pensara como product person y codeara como senior. Conseguimos las dos cosas, en una sola persona, con un precio claro y sin overhead de agencia.",
                author: "Head of Product · UserDao",
                place: "Estudio Web3",
            },
            {
                body:
                    "Reconstruyó nuestro flujo WooCommerce → BuddyPress en dos días. Lo que nuestro desarrollador anterior estimó en seis semanas.",
                author: "CTO · ThemeKraft",
                place: "Alemania",
            },
        ],
    },
    pricing: {
        overline: "Precios honestos",
        headlineA: "Empieza con un assessment.",
        headlineEm: "Después, un número real.",
        intro:
            "Cada engagement comienza con un assessment pagado para que el alcance sea real antes de comprometernos. A partir de ahí mando una sola propuesta con un número de partida. El cuidado es opcional, mensual y cancelable en cualquier momento.",
        afterLaunchOverline: "Después del lanzamiento",
        afterLaunchTitle: "Cuidado mensual, por las mismas manos que lo construyeron.",
        afterLaunchBody:
            "Tres niveles ligeros, definidos en una llamada después del lanzamiento. Cancelas con siete días de aviso — sin retainers, sin penalidades de salida.",
        tiers: [
            {
                name: "Assessment",
                price: "$500",
                cadence: "desde · 1–2 días · te quedas con el entregable",
                for: "Para quien quiera una lectura honesta de su problema, stack o negocio antes de comprometerse",
                includes: [
                    "Llamada de descubrimiento + cuestionario async",
                    "Revisión de arquitectura, stack y costo",
                    "Alcance escrito + siguiente paso recomendado",
                    "Es tuyo — incluso si no construimos juntos",
                    "Se acredita al build si continúas",
                ],
                cta: "Reservar el assessment",
            },
            {
                name: "Sitio web",
                price: "desde $3,780",
                cadence: "desde · entregado en 1–3 semanas",
                for: "Restaurantes, venues, estudios, tiendas de un solo producto",
                includes: [
                    "Sitio editorial de 4–6 páginas, diseñado a medida",
                    "No es una plantilla de Squarespace ni Wix",
                    "Captura de leads (formulario, WhatsApp, SMS, Calendly)",
                    "Aparecés en Google — perfil de negocio configurado",
                    "Panel opcional para editar vos mismo",
                ],
                cta: "Iniciar un sitio",
            },
            {
                name: "Herramienta interna",
                price: "desde $6,650",
                cadence: "desde · cuidado mensual posible",
                for: "Herramientas privadas para tu equipo — dashboards, paneles, sistemas de pedidos/inventario",
                includes: [
                    "Una herramienta privada ajustada a cómo ya trabajás",
                    "Se conecta con los sistemas que ya usás (pagos, e-commerce, etc.)",
                    "Cada miembro del equipo ve solo su parte, con historial de cambios",
                    "La ves funcionando desde el día uno, no solo al final",
                    "Cuidado mensual opcional desde el lanzamiento",
                ],
                cta: "Definir una herramienta",
            },
        ],
        care: [
            ["Care · Light", "Hosting, backups, parches de seguridad, hasta 1h de cambios pequeños al mes."],
            ["Care · Standard", "Todo lo de Light más hasta 4h de nuevas features o contenido al mes."],
            ["Care · Studio", "Canal prioritario en Slack/WhatsApp más hasta 10h de trabajo al mes."],
        ],
    },
    faq: {
        overline: "Respuestas honestas",
        headlineA: "Lo que la gente pregunta",
        headlineEm: "antes de la llamada.",
        intro:
            "Si tu pregunta no está aquí, escríbeme por WhatsApp — normalmente respondo el mismo día.",
        items: [
            {
                q: "¿Esto es de verdad un solo desarrollador, o una agencia escondida?",
                a: "Solo yo, Guillermo. Sí tengo una empresa de software aparte (Scalater DEV LLC) para engagements más grandes, y gfirem es parte de eso — pero este sitio existe específicamente para trabajo directo, uno a uno, con negocios pequeños y founders.",
            },
            {
                q: "¿Construyes MVPs?",
                a: "Sí — un MVP es simplemente una primera versión funcional de un producto: pequeña para lanzar rápido, real para vender. Ya sea que le digas MVP, prototipo o Versión 1, esa es la forma que toman la mayoría de mis proyectos de sistema a medida. Si la palabra \"MVP\" no te suena, no hay problema — hablamos de tu problema, no del vocabulario técnico.",
            },
            {
                q: "¿Por qué un assessment pagado primero?",
                a: "Porque $500 de pensar con cuidado al inicio nos ahorra semanas de supuestos equivocados después. Te llevas un informe escrito de tu problema, stack y siguiente paso recomendado — tuyo, incluso si no construimos juntos. Si continúas, el assessment se acredita al build.",
            },
            {
                q: "¿Cuánto suelen tardar los builds?",
                a: "La mayoría de los builds aterrizan entre 1 y 3 semanas de trabajo activo después del assessment, dependiendo del alcance. Sistemas a medida con varias integraciones pueden tomar más — pero siempre tendrás un solo número y un solo plazo antes de empezar.",
            },
            {
                q: "¿Escribes el copy y consigues las fotos?",
                a: "Puedo hacer una primera pasada del copy y conseguir imágenes de stock o generadas con IA, especialmente para landings. Si tienes marca o fotógrafo, mejor todavía — me encanta diseñar alrededor de material real.",
            },
            {
                q: "¿Puedo cancelar el mantenimiento cuando quiera?",
                a: "Sí. El cuidado mensual es mes a mes, cancelable con 7 días de aviso. Sin retainers de 12 meses, sin penalidades de salida.",
            },
            {
                q: "¿Dónde estás basado y con qué husos horarios trabajas?",
                a: "Estoy basado en Austin, Texas (hora central de EE.UU.) y trabajo cómodamente con clientes de EE.UU., LATAM y Europa. Respondo WhatsApp y email en horario laboral, el mismo día.",
            },
        ],
    },
    contact: {
        overline: "Empieza la conversación",
        headlineA: "Cuéntame de",
        headlineEm: "tu problema.",
        headlineB: "Te diré honestamente si puedo resolverlo.",
        intro:
            "Elige el canal en el que seas más rápido. Las llamadas de descubrimiento son gratis y no hay ningún \"funnel\" del otro lado — solo yo, con un cuaderno abierto.",
        ctaCall: "Agendar llamada de descubrimiento",
        ctaWhatsapp: "Mensaje por WhatsApp",
        rowWhatsapp: "WhatsApp",
        rowCalendly: "Calendly",
        rowEmail: "Email",
        rowLocation: "Basado en",
        rowAvailability: "Disponibilidad",
        availabilityValue: "Aceptando 3 proyectos pequeños",
        localeTag: "es-ES",
    },
    footer: {
        tagline:
            "Un estudio independiente de uno. Construyendo software para negocios pequeños en silencio, desde mucho antes de que fuera un nicho.",
        location: "Trabajando con clientes de EE.UU., LATAM y EU.",
        partOf: "gfirem es parte de Scalater DEV LLC",
        siteLabel: "Sitio",
        reachLabel: "Contáctame",
        bookCall: "Agendar llamada de descubrimiento",
        siteLinks: [
            ["#manifesto", "Sobre mí"],
            ["#services", "Qué resuelvo"],
            ["#work", "Casos de estudio"],
            ["#pricing", "Precios"],
            ["#contact", "Contacto"],
        ],
        copy: "Una práctica solo de Guillermo Figueroa Mesa · parte de Scalater DEV LLC.",
        quote:
            "\u201CNo importa el lenguaje ni la tecnología — resuelve el rompecabezas que tienes enfrente.\u201D",
    },
    meta: {
        title:
            "Desarrollador de Software a Medida en Austin | Guillermo Figueroa",
    },
    notFound: {
        code: "404",
        overline: "Puerta equivocada",
        title: "Esta página se fue a dar una vuelta al agua.",
        body:
            "Lo que buscabas no está aquí — quizá el enlace envejeció, quizá lo moví, quizá nunca existió. Nada se rompió; simplemente aterrizaste en una página que no forma parte del estudio.",
        ctaHome: "Volver al inicio",
        ctaWork: "Leer los casos de estudio",
        ctaContact: "Escríbeme mejor",
    },
    blog: {
        metaTitle: "Notas de campo · Software a medida para pequeños negocios | gfirem",
        metaDescription:
            "Guías honestas, comparaciones y lecciones sobre contratar a un desarrollador solo para una herramienta de pequeño negocio — desde un builder con 20+ años en el campo.",
        overline: "Notas de campo",
        title: "Guías honestas para dueños de negocio que están evaluando software a medida.",
        lede: "Comparaciones, guías de compra y lecciones de 20+ años entregando herramientas que se pagan solas.",
        empty: "Primer artículo llegando pronto — vuelve esta semana.",
        fallbackNotice: "Notas próximamente en español · mostrando la versión original en inglés",
        backToIndex: "Todas las notas",
        writtenBy: "Escrito por",
        moreNotes: "Leer más notas →",
    },
    toggle: {
        en: "EN",
        es: "ES",
        aria: "Cambiar idioma",
    },
};

export default es;
